import { css } from '@emotion/css';

export const LinkBtn = css`
  padding: 0px;
`;
